var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0.5C8.72386 0.5 8.5 0.723858 8.5 1V4.5H3C2.72386 4.5 2.5 4.72386 2.5 5C2.5 5.27614 2.72386 5.5 3 5.5H9H15H21C21.2761 5.5 21.5 5.27614 21.5 5C21.5 4.72386 21.2761 4.5 21 4.5H15.5V1C15.5 0.723858 15.2761 0.5 15 0.5H9ZM14.5 4.5V1.5H9.5V4.5H14.5ZM5 7.5C5.27614 7.5 5.5 7.72386 5.5 8V21.5H18.5V8C18.5 7.72386 18.7239 7.5 19 7.5C19.2761 7.5 19.5 7.72386 19.5 8V22C19.5 22.2761 19.2761 22.5 19 22.5H5C4.72386 22.5 4.5 22.2761 4.5 22V8C4.5 7.72386 4.72386 7.5 5 7.5ZM10 9.5C10.2761 9.5 10.5 9.72386 10.5 10V18C10.5 18.2761 10.2761 18.5 10 18.5C9.72386 18.5 9.5 18.2761 9.5 18V10C9.5 9.72386 9.72386 9.5 10 9.5ZM14.5 10C14.5 9.72386 14.2761 9.5 14 9.5C13.7239 9.5 13.5 9.72386 13.5 10V18C13.5 18.2761 13.7239 18.5 14 18.5C14.2761 18.5 14.5 18.2761 14.5 18V10Z",
    fill: "#27282B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/Remove.c41dcda6221e2875c086de5b22bbd1a8.svg";
export { ForwardRef as ReactComponent };